import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const InvitationPage = lazy(() => import('@/modules/auth/pages/InvitationPage.tsx'));
const SignUpUserPage = lazy(() => import('@/modules/auth/pages/SignUpPage.tsx'));

export const authPaths = {
  static: {
    invitation: '/invitation',
    signup: '/sign-up',
  },
};

export const getAuthRoutes = () => {
  const router: RouteObject[] = [
    {
      path: authPaths.static.invitation,
      element: <InvitationPage />,
    },
    {
      path: authPaths.static.signup,
      element: <SignUpUserPage />,
    },
  ];

  return router;
};
